<template>
	<div class="loginBg">
		
		<div class="login-lang">
			<LanguageSwitch />
		</div>
		<div class="login-card">
			<Card>
				<h2 style="margin-top: 5px;">{{ $t('login_title')}}</h2>
				<Form ref="formInline" :model="formInline" :rules="ruleInline" style="margin-top: 40px;">
					<FormItem style="color: white;margin-bottom: 30px;" prop="UserName">
						<Input type="text" v-model="formInline.UserName" :placeholder="$t('login_username_placeholder')">
						<Icon color="red" size="20" type="ios-person-outline" slot="prepend"></Icon>
						</Input>
					</FormItem>
					<FormItem prop="UserPassword">
						<Input type="password" v-model="formInline.UserPassword"
							:placeholder="$t('login_password_placeholder')"
							@keypress.enter.native="handleSubmit('formInline')">
						<Icon color="red" size="20" type="ios-lock-outline" slot="prepend"></Icon>
						</Input>
					</FormItem>
					<FormItem>
						<Button style="width: 100%;margin-top: 25px;" size="large" type="primary"
							@click="handleSubmit('formInline')">{{$t('login_button')}}</Button>
					</FormItem>
				</Form>
			</Card>
		</div>
		<!-- <div
			style="position: fixed;font-weight: bold;color: white;text-align: center;height: 50px;width: 100%;bottom: 0px;">
			{{IcpOperator.Comapy}} <a class="text-white" href="http://beian.miit.gov.cn"
				target="_blank">{{IcpOperator.ICP}}</a></div> -->
	</div>
</template>
<script>
	import axios from "axios";
	import Qs from "qs";
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../webapi';
	import routerUtils from '../../router.js';
	export default {
		data() {
			return {
				formInline: {
					// UserName: 'developer',
					// UserPassword: '123456',
					UserName: '',
					UserPassword: ''
				},
				timer: ''
			}
		},
		beforeDestroy() {
			// if (this.timer) {
			// 	clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
			// }
		},
		created() {

		},
		mounted() {
			localStorage.removeItem('AccessToken')
			localStorage.removeItem('RefreshToken')
			localStorage.removeItem('UserName')
			localStorage.removeItem('UserMenus')
			localStorage.removeItem('topMenus')
			localStorage.removeItem('menuFlag')
			localStorage.clear();
			if (process.env.NODE_ENV === "development") {
				this.GetIcpOperator('127.0.0.1');
			} else {
				this.GetIcpOperator(window.location.href.split("/")[2]);
			}
			if (this.$router.params && this.$router.params.isLogout == 1) {
				window.reload();
			}
		},
		computed: {
			...mapState({
				IcpOperator: 'IcpOperator'
			}),
			// 校验规则随语言实时变化
			ruleInline() {
				return {
					UserName: [{
						required: true,
						message: this.$t('login_username_required'),
						trigger: 'blur'
					}],
					UserPassword: [{
							required: true,
							message: this.$t('login_password_required'),
							trigger: 'blur'
						},
						{
							type: 'string',
							min: 6,
							message: this.$t('login_password_min'),
							trigger: 'blur'
						}
					]
				}
			}
		},
		methods: {
			...mapActions([
				'GetIcpOperator',
			]),
			handleSubmit(name) {
				const _this = this
				const param = _this.formInline
				localStorage.removeItem('AccessToken')
				localStorage.removeItem('RefreshToken')
				localStorage.removeItem('UserName')
				localStorage.removeItem('UserMenus')
				localStorage.removeItem('topMenus')
				localStorage.removeItem('menuFlag')
				//mapState.hasMenus=false
				this.$refs[name].validate((valid) => {
					if (valid) {
						_this.$axios.post(webapi.base_api_url + "/Home/Login",
							param
						).then(res => {
							console.log("login")
							console.log(res)
							if (res.data.Code == 0) {
								localStorage.setItem("AccessToken", res.data.Data.AccessToken);
								localStorage.setItem("RefreshToken", res.data.Data.RefreshToken);
								localStorage.setItem("UserName", this.formInline.UserName)
								localStorage.removeItem("topMenus")
								localStorage.setItem("menuFlag", 'load')
								localStorage.setItem("RefreshTokenTime", res.data.Data.ExpiresIn)
								let curTime = new Date();
								let expireTime = curTime.valueOf() + (res.data.Data.ExpiresIn - 300) *
								1000;
								console.log("过期时间", new Date(expireTime));
								localStorage.setItem("AccessTokenExpires", expireTime);
								//sessionStorage.setItem("first", 'yes');
								_this.getUserMenus().then(res => 
								{
									// _this.$router.push(res.data.Data.List[0].path);
								});
								//_this.timer = setInterval(_this.getVersion, 3600);
								//this.$router.push("/StationMonitoring/DeviceStatus")
								this.formInline.UserName = '';
								this.formInline.UserPassword = '';
							} else {
								this.$Message.success(res.data.Msg + "---" + res.data.Data);
								this.$router.push("/login")
							}
						}).catch(error => {
							console.log(error);
							this.$Message.success(error.response.data.Msg + "---" + error.response.data
								.Data);
						})
					}
				})
			},

			getUserMenus() {
				const _this = this
				return _this.$axios.post(webapi.base_api_url + "/Home/GetUserMenus", {}).then(res => {
					console.log("获得用户菜单")
					console.log(res)
					if (res.data.Code == 0) {
						// 	let menus = [];
						// res.data.Data.Menus.forEach(function(value, index, array) {
						// 	value.forEach(function(value2, index, array) {
						// 		if (value2.Title != "场站总览") {
						// 			menus.push(value2)
						// 		}

						// 	})
						// })
						// console.log(menus)
						localStorage.setItem("UserMenus", JSON.stringify(res.data.Data.List));
						routerUtils.userRoute();
						
						const first = res.data.Data.List.find(item => item.length > 0);
						_this.$router.push(first[0].path);
					} else {
						console.log("获得用户菜单错误")
					}
				})
			},

			getRefreshToken() {
				const _this = this
				_this.$axios.post(webapi.base_api_url + "/Home/RefreshToken", {
					RefreshToken: localStorage.getItem("RefreshToken")
				}).then(res => {
					console.log("刷新token定时器")
					if (res.data.Code == 0) {
						console.log(res.data.Data.AccessToken)
						localStorage.setItem("AccessToken", res.data.Data.AccessToken);
						localStorage.setItem("RefreshToken", res.data.Data.RefreshToken)
					} else {
						console.log("刷新token定时器请求错误")
						_this.$router.push("/login")
					}
				})
			},
		}
	}
</script>

<style>
	.loginBg {
		background-image: url(../../assets/login.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;

		background-position: center 0;
		height: 100%;
		width: 100%;
		text-align: center;
		display: flex;
		flex-direction: column;
		justify-content: center;
		justify-items: center;
		width: 100%;
	}
	
	/* 语言切换：固定在最右上角，位于公告滚动条上方 */
	.login-lang {
		position: fixed;
		top: 12px;
		right: 20px;
		color: #ffffff;
		font-size: 1rem;
		z-index: 30;
	}
	
	.loginBg .login-card {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: center;
	}
	
	.loginBg .ivu-card-bordered {
		width: 400px;
		height: 320px;
		text-align: center;
		/* margin: 10% auto; */
		opacity: 0.75;
		background: #0b1f76;
		border: 1px solid #00219a;
		border-radius: 15px;
		color: white;
		/* color: #000000 !important; */
	}

	.loginBg .ivu-form-item-label {
		color: #ffffff !important;
	}

	.loginBg .ivu-input {
		color: #ffffff !important;
		background: #050B2D;

	}

	.loginBg .ivu-card-bordered,
	.ivu-card {
		margin-right: 0;
		margin-top: 0%;
	}
	
	.text-white {
		color: white;
	}
	.text-white:hover {
		color: #93B5C2
	}
	
	/* 滚动容器：隐藏溢出（下移到语言切换按钮下方） */
	.scroll-wrap {
		overflow: hidden;
		border: 1px solid #eee;
		color: fa8c16;
		background-color: #fff7e6;
		position: absolute;
		top: 3.2rem;
		left: 10px;
		right: 10px;
		font-size: 1.2rem;
		border-radius: 10px;
		padding-left: 10px;
	}

	/* 滚动内容：执行动画 */
	.scroll-content {
		display: inline-block;
		white-space: nowrap; /* 不换行 */
		animation: rowScroll 50s linear infinite; /* 匀速无限滚动 */
		padding-left: 100%; /* 关键：实现无缝 */
	}

	/* 动画定义：从右 → 左 */
	@keyframes rowScroll {
		0% {
			transform: translateX(0%);
		}
		100% {
			transform: translateX(-100%);
		}
	}
</style>
